import Reports from './Reports';
export default Reports;



// WEBPACK FOOTER //
// ./src/containers/Reports/index.js